import ReducerUtils from "../../../utils/ReducerUtils"
import Actions      from "../../../model/constant/actions"


const retrievingNegativeKeywords = ReducerUtils.createReducer(false,{
  [Actions.RETRIEVING_BRANDING_KEYWORDS] : (state,action)=>action.status,
})

export default retrievingNegativeKeywords
